<template>
	<div class="p-grid">
		<div class="p-col-12">
            <h3 style="color:#ffcc2a;">{{$t('Reporte')+': '+$t('Renovaciones')}} </h3>
		</div>
        <div class="p-col-12">
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-3">
                        <SelectButton v-model="option" :options="options" :optionLabel="$t('nombre')" aria-labelledby="basic"/>
                    </div>
                    <div class="p-col-8 p-grid">
                        <div class="p-col-3" v-if="option.code>0">
                            <Dropdown v-model="tipo" :options="tipos" :optionLabel="$t('nombre')" :placeholder="$t('Seleccione...')"></Dropdown>
                        </div>
                        <div class="p-col-2" v-if="option.code==1">
                            <Dropdown v-model="year" :options="$store.state.years2" optionLabel="nombre"></Dropdown>
                        </div>
                        <div class="p-col-2" v-if="option.code==1">
                            <Dropdown v-model="mes" :options="$store.state.meses" :optionLabel="$t('nombre')" :placeholder="$t('Seleccione...')"></Dropdown>
                        </div>
                        <div class="p-col-3" v-if="option.code==2">
                            <InputMask v-model="fecha1" placeholder="DD/MM/YYYY" slotChar="DD/MM/YYYY" mask="99/99/9999"/>
                        </div>
                        <div class="p-col-3" v-if="option.code==2">
                            <InputMask v-model="fecha2" placeholder="DD/MM/YYYY" slotChar="DD/MM/YYYY" mask="99/99/9999"/>
                        </div>
                        <div class="p-col-9" v-if="option.code==0">
                            <InputText v-model="buscar" type="number"/>
                        </div>
                    </div>
                    <div class="p-col-1">
                        <Button icon="pi pi-search" class="p-button-rounded p-button-primary p-mr-1" v-tooltip.bottom="$t('Buscar')"  @click="Buscar()"/>
                    </div>
                </div>
            </div>
        </div>
		<div class="p-col-12" v-if="tipo">
			<div class="card">
                <!-- Vehiculo -->
                <DataTable :value="facturas" :scrollable="true" scrollHeight="400px"  v-model:selection="selectedCustomers" :filters="filters" class="p-datatable-sm"
					:paginator="true" :rows="25">
                    <template #header>
                        <div class="table-header">
                            <span class="p-input-icon-right">
                                <i class="pi pi-search"/>
                                <InputText v-model="filtro" placeholder="Buscar..." @keyup="Filtrar"/>
                                <!--<InputText v-model="filters['global']" :placeholder="$t('Buscar')+'...'" />-->
                            </span>
                            <Button icon="pi pi-download" class="p-button-rounded p-button-warning p-mr-2" @click="VerXLS()" v-if="facturas.length>0"/>
                        </div>
                    </template>
                    <Column :header="$t('Nro')" headerStyle="width: 50px">
                        <template #body="slotProps">
                            {{slotProps.index+1}}                              
                        </template>
                    </Column>   
                    <Column field="codigo" :header="$t('Número Póliza')" :sortable="true" headerStyle="width: 200px">
                        <template #body="slotProps">
                            {{slotProps.data.codigo}}                        
                        </template>
                    </Column>
                    <Column field="cliente" :header="$t('Customer')+' #'" headerStyle="width: 120px">
                        <template #body="slotProps">
                            {{slotProps.data.cliente}}                              
                        </template>
                    </Column>
                    <Column field="nombre" :header="$t('Nombre Completo')+' #'" headerStyle="width: 250px">
                        <template #body="slotProps">
                            {{slotProps.data.nombre}}                            
                        </template>
                    </Column>
                    <Column field="activacion" :header="$t('Activación')" :sortable="true" headerStyle="width: 120px">
                        <template #body="slotProps">
                            {{slotProps.data.activacion}}
                        </template>
                    </Column>
                    <Column field="vence" :header="$t('Vencimiento')" :sortable="true" headerStyle="width: 120px">
                        <template #body="slotProps">
                            {{slotProps.data.vence}}
                        </template>
                    </Column>
                    <Column :header="$t('Prima Total')" headerStyle="width: 130px">
                        <template #body="slotProps">
                            {{moneda(slotProps.data.monto)}}
                        </template>
                    </Column>
                    <Column field="celular" :header="$t('Teléfono móvil')" headerStyle="width: 120px">
                        <template #body="slotProps">
                            {{slotProps.data.celular}} 
                        </template>
                    </Column>
                    <Column :header="$t('Teléfono privado')" field="tlflocal" headerStyle="width: 120px">
                        <template #body="slotProps">
                            {{slotProps.data.tlflocal}}                              
                        </template>
                    </Column>                 
                </DataTable>
            </div>
        </div>
	</div>
	

</template>

<script>
import API from "../service/ApiConsulta";
import { useI18nPlugin } from '@unify/vuex-i18n';
import url from "@/service/_URL";
import PDF from "../service/PDF";
import XLS from "../service/XLS";

export default {
	components: {
    },
	data() {
		return {
			insert: false,
			edit: false,
			del: false,
			i18n: null,
            caso: null,
            facturas: [],
			selectedCustomers: null,
			filters: {},
			url: null,
			option: {code: 1, nombre: 'Mes', name: 'Month'},
			options: [
				{code: 0, nombre: 'Póliza', name: 'Policy'},
				{code: 1, nombre: 'Mes', name: 'Month'},
				{code: 2, nombre: 'Fecha', name: 'Date'},
			],
            tipo: null,
            tipos: [],
			year: null,
			mes: null,
			buscar: null,
            monto: 0,
            pagos: 0,
            deudas: 0,
            efectivo: 0,
            iss: 0,
            broker: 0,
            fecha1: null,
            fecha2: null,
            resultado: [],
            calculando: false,
		}
	},
	productService: null,
	eventService: null,
	created() {
		this.year = this.$store.state.years2[2];
		this.mes = this.$store.state.mes;
		this.url = url;
		this.i18n = useI18nPlugin();
		this.$store.commit('Validar',this.$route);
		if (this.$store.state.mobile){this.size = '90vw';}
        this.Mostrar();		
	},
	mounted() {
	},
	methods: {
        Mostrar(){
			this.$store.commit('Loading');
			this.totaldeudas = 0;
            const Consulta = new API('Reportes');
            Consulta.Ini('Report15').then(result => {
                //this.$store.state.error = result;	
				this.insert = result.insert;
				this.edit = result.edit;
				this.del = result.delete;
                this.tipos = result.consult.tipos;
                this.$store.commit('Loading');
            }); 
        },
        Filtrar() {
			if (this.filtro==null || this.filtro==''){
				this.facturas = this.resultado;
			} else {
				this.facturas = [];
				this.facturas = this.resultado.filter(val => 
					val.codigo.toUpperCase().includes(this.filtro.toUpperCase()) ||
                    val.nombre.toUpperCase().includes(this.filtro.toUpperCase()) ||
                    val.created.nombre.toUpperCase().includes(this.filtro.toUpperCase()) ||
                    val.created.origen.toUpperCase().includes(this.filtro.toUpperCase())
				);	
			}
		},
        VerXLS(){
            const xls = new XLS();
            xls.Reporte15(this.facturas);
		},
        Buscar(){
			if((this.option.code==1 && this.tipo && this.mes && this.year)
                || (this.option.code==2 && this.tipo && this.fecha1 && this.fecha2)
                || (this.option.code==0 && this.buscar)
            ){
				this.$store.commit('Loading');
				this.facturas = [];
				const Consulta = new API('Reportes');
				Consulta.Procesar('Report15',{
					caso: 	'Buscar',
					opcion: this.option.code,
					mes: this.mes.code,
					year: this.year.code,
					tipo: this.tipo,
                    fecha1: Consulta.fdate(this.fecha1),
                    fecha2: Consulta.fdate(this.fecha2),
					poliza: this.buscar,
					}).then(response => {
						//this.$store.state.error = response;
                        this.resultado = response.result.ventas;
                        this.Filtrar();
						this.$store.commit('Loading');
					});
			}
        },
        Ver(data){
            const doc = new PDF();
            doc.Factura(data);
        },
        convfech(fecha){
            return fecha.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
		},
		toggle1(event) {
			this.$refs.op1.toggle(event);
		},
		toggle2(event) {
			this.$refs.op2.toggle(event);
		},
		toggle3(event) {
			this.$refs.op3.toggle(event);
		},
        moneda(number){
            return new Intl.NumberFormat("en", {style: "currency", currency: this.$store.state.currency}).format(parseFloat(number).toFixed(2));
		},
	},
	computed: {

    }

}
</script>
<style scoped lang="scss">
.table-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
	width: 150px;
	margin: 0 auto 2rem auto;
	display: block;
}

.confirmation-content {
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;

	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}

	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}

	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
    display: none;
}

@media screen and (max-width: 40em) {
    ::v-deep(.p-datatable) {
        &.p-datatable-responsive-demo {
            .p-datatable-thead > tr > th,
            .p-datatable-tfoot > tr > td {
                display: none !important;
            }

            .p-datatable-tbody > tr > td {
                text-align: left;
                display: block;
                width: 100%;
                float: left;
                clear: left;
                border: 0 none;

                .p-column-title {
                    padding: .4rem;
                    min-width: 30%;
                    display: inline-block;
                    margin: -.4em 1em -.4em -.4rem;
                    font-weight: bold;
                }

                &:last-child {
					border-bottom: 1px solid var(--surface-d);
					text-align: center;
				}
				
				.p-rating {
					display: inline-block;
				}
            }
        }
    }
}
</style>
